import React from 'react'
import cx from 'classnames'

import { Icon, AlertOctagonIcon } from 'components/shared/Icon/Icon'

import styles from './FormFieldError.module.scss'

type FormFieldErrorProps = {
  className?: string
  error?: React.ReactNode
}

export const FormFieldError = ({ className, error }: FormFieldErrorProps) => {
  if (!error) {
    return null
  }

  return (
    <p className={cx(styles.error, className)}>
      <Icon className={styles.icon} icon={AlertOctagonIcon} size={16} />
      <span className={styles.text}>{error}</span>
    </p>
  )
}
